<template>
  <div class="examineBox myStatementApply">
    <self-back :pageHeaderList="[{'name':'我的结算单申请'}]"></self-back>
    <div class="containter" v-loading='loading'>
      <ul class="topTab">
        <!-- <li :class="tab == 1 ? 'active' : ''" @click="tab = 1;status=''">销售结算单</li> -->
        <li :class="tab == 2 ? 'active' : ''" @click="tab = 2;status=''" v-if="userInfo.role_id != 11">MCN结算单</li>
        <li :class="tab == 5 ? 'active' : ''" @click="tab = 5;status=''" v-if="userInfo.role_id != 9">游戏/电商结算单</li>
        <li :class="tab == 6 ? 'active' : ''" @click="tab = 6;status=''" v-if="userInfo.role_id != 9">拼多多结算单</li>
        <li :class="tab == 4 ? 'active' : ''" @click="tab = 4;status=''" v-if="userInfo.role_id != 9">CPA结算单</li>
        <div style="float:right;margin-top:12px">
          <label style="font-size:13px">财务审核时间：</label>
          <el-date-picker @change="getStatementsIndex(1)" style="width:240px" v-model="approved_date" type="daterange" value-format="yyyy-MM-dd" size='mini' range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
          </el-date-picker>
        </div>
      </ul>
      <div style="margin: 0 16px 16px;" class="topSelect">
        <label>审核状态：</label>
        <el-select v-model="status" @change="getStatementsIndex(1)" style="width:130px" size="mini" clearable placeholder="审核状态">
          <el-option v-for="(item,index) in statusList" :key="index" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <!-- <label>消耗表月份：</slabel> -->
        <el-date-picker @change="getStatementsIndex(1)" style="width:140px;" v-model="screenMonth" :clearable='true' type="month" size="mini" value-format="yyyy-MM" placeholder="月份筛选">
        </el-date-picker>
        <label>申请日期：</label>
        <el-date-picker @change="getStatementsIndex(1)" v-model="timeMonth" style="width:240px" type="daterange" size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
        </el-date-picker>
        <label>客户名称：</label>
        <el-select style="width:160px" v-if="tab == 2" @change="getStatementsIndex(1)" v-model="customer_name" size='mini' :clearable='true' filterable placeholder="请选择客户全称">
          <el-option v-for="(item,index) in mcnKeHuList" :key="index" :label="item.name" :value="item.name">
          </el-option>
        </el-select>
        <el-select style="width:160px" v-else @change="getStatementsIndex(1)" v-model="customer_name" size='mini' :clearable='true' filterable placeholder="请选择客户全称">
          <el-option v-for="(item,index) in customerList" :key="index" :label="item.customer_name" :value="item.customer_name">
          </el-option>
        </el-select>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 306px)" border>
          <el-table-column prop="id" label="序列号" align='center' width="80"></el-table-column>
          <el-table-column prop="amount" label="订单金额" align='center' width="90"></el-table-column>
          <el-table-column prop="customer_name" label="客户名称" align='center' width="200"></el-table-column>
          <el-table-column prop="company" label="签约公司" align='center' width="200"></el-table-column>
          <el-table-column prop="apply_time" align='center' label="申请时间"></el-table-column>
          <el-table-column align='center' label="是否作废">
            <template slot-scope="scope">
              <img v-if="scope.row.is_voided==1" src="@/assets/img/voided.png" style="width:40px;height:29px;margin:auto" alt="">
            </template>
          </el-table-column>
          <el-table-column prop="voided_statements_id" align='center' label="作废序列号"></el-table-column>
          <el-table-column align='center' label="状态">
            <template slot-scope="scope">
              <span v-if="scope.row.verify_status == 0">已保存</span>
              <span v-if="scope.row.verify_status == 1" style="color:#EF7400">商务待审核</span>
              <span v-if="scope.row.verify_status == 2" style="color:#8a8223">财务待审核</span>
              <span v-if="scope.row.verify_status == 3" style="color:#d51313">商务审核驳回</span>
              <span v-if="scope.row.verify_status == 4" style="color:#00BB5D">财务审核通过</span>
              <span v-if="scope.row.verify_status == 5" style="color:#d51313">财务审核驳回</span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作">
            <template slot-scope="scope">
              <button class="detailButton" :style="scope.row.enable_apply == 1?'background:#ff9b3b':''" @click="goDetail(scope.row)">{{scope.row.enable_apply == 1?'重新申请':'申请详情'}}</button>
              <button class="detailButton" style="background:#ff9b3b" @click="goInvoiceDetail(scope.row)" v-if="scope.row.invoice_status == 1">申请开票</button>
              <!-- <button class="detailButton" style="background:#f66034" @click="statementsDelVerify(scope.row)" v-if="scope.row.verify_status == 0 || scope.row.verify_status == 1 || scope.row.verify_status == 3 || scope.row.verify_status == 5">撤销申请</button> -->
              <button class="detailButton" style="background:#f66034" @click="statementsDelVerify(scope.row)">撤销申请</button>
              <button class="detailButton" style="background:#ff9b3b" @click="onClickSealBtn(scope.row)" v-if="scope.row.seal_status == 1">结算单盖章</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </div>
    <el-dialog title="开票信息填写" :visible.sync="invoiceFillingFlag" width="60%" top="10vh" :close-on-click-modal='false'>
      <invoice-filling v-if="invoiceFillingFlag" :dataList='fillingData' @updateList="invoiceFillingFlag=false;getStatementsIndex(page)" @closeToast='invoiceFillingFlag=false;'></invoice-filling>
    </el-dialog>

    <!-- S 申请结算单盖章 -->
    <el-dialog title="申请结算单盖章" :visible.sync="crtSeal.visible" width="500px" top="10vh" :close-on-click-modal='false' @close="onSealCancel">
      <div class="item">
        <label><em class="stars">*</em>类型</label>
        <el-select style="width:260px" v-model="crtSeal.type" size='mini' filterable placeholder="请选择">
          <el-option v-for="item in sealTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
        </el-select>
      </div>
      <div slot="footer" style="text-align: center;margin-top:30px">
        <el-button type="primary" size='small' @click="onSealConfirm">提 交</el-button>
        <el-button size='small' @click="onSealCancel">取 消</el-button>
      </div>
    </el-dialog>
    <!-- E 申请结算单盖章 -->
  </div>
</template>
<script>
import invoiceFilling from './invoice/InvoiceFilling'
export default {
  components: {
    invoiceFilling
  },
  data () {
    return {
      invoiceFillingFlag: false,
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 2,
      accountList: [],
      status: '',
      statusList: [
        { value: 1, label: '商务待审核' },
        { value: 2, label: '商务审核通过' },
        { value: 3, label: '商务审核失败' },
        { value: 2, label: '财务待审核' },
        { value: 4, label: '财务审核通过' },
        { value: 5, label: '财务审核失败' },
      ],
      timeMonth: '',
      screenMonth: '',
      customerList: [],
      customer_name: '',
      statement_id: '',
      fillingData: {},
      mcnKeHuList: [],
      userInfo: {},
      approved_date: [],

      sealTypeOptions: [
        { label: '含本公司结算单盖章', value: 1 },
        { label: '仅客户公司结算单盖章', value: 2 },
      ],
      crtSeal: { // 申请盖章信息
        visible: false,
        info: {},
        type: '',
      },
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.userInfo.role_id == 11) {
      this.tab = 5;
    }
    this.mcnListEvent()
    this.customerListEvent()
    this.getStatementsIndex(1)
  },
  mounted () {
  },
  methods: {
    statementsDelVerify (data) {//撤销申请
      this.$confirm('确定要撤销此次申请', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.statementsDelVerify, {
          id: data.id
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.getStatementsIndex(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch((action) => {
      });
    },
    goInvoiceDetail (data) {
      this.fillingData = data;
      this.invoiceFillingFlag = true;
    },
    goDetail (data) {
      this.statement_id = data.id;
      let routeData = this.$router.resolve({
        path: '/statementDetail/' + this.tab + '?id=' + this.statement_id + '&enable_apply=' + data.enable_apply,
      })
      this.$winopen(routeData.href)
    },
    handleCurrentChange (val) {
      this.getStatementsIndex(val)
    },
    getStatementsIndex (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsIndex, {
        params: {
          type: this.tab,
          is_my: 1,
          month: this.screenMonth,
          status: this.status,
          page: page,
          page_size: this.page_size,
          apply_start_date: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[0] : '',
          apply_end_date: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[1] : '',
          customer_name: this.customer_name,
          approved_start_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[0] : '',
          approved_end_date: this.approved_date && this.approved_date.length > 0 ? this.approved_date[1] : '',
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    mcnListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.mcnList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.mcnKeHuList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },
    customerListEvent () {
      this.$axios.get(this.URL.BASEURL + this.URL.customerList, {
        params: {
          page: 1,
          page_size: 999,
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          this.customerList = res.rst.data;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
      })
    },

    /* S 申请结算单盖章 */
    onClickSealBtn(row) {
      this.crtSeal.info = {...row}
      this.crtSeal.visible = true
    },
    onSealCancel() {
      this.crtSeal.info = {}
      this.crtSeal.type = ''
      this.crtSeal.visible = false
    },
    onSealConfirm() {
      const { type, info } = this.crtSeal
      if (!type) return this.$message.warning('请选择结算单盖章类型')
      const routeData = this.$router.resolve({
        path: `/statementSealDetail/${this.tab}?id=${info.id}&enable_apply=${info.enable_apply}&sealType=${type}&action=2`,
      })
      this.$winopen(routeData.href)
      this.onSealCancel()
    },
    /* E 申请结算单盖章 */
  },
  watch: {
    tab () {
      this.getStatementsIndex(1);
      this.customer_name = '';

    }
  }
}
</script>
<style lang="scss" scoped>
@import "./statementApply.scss";
.item {
  margin-bottom: 20px;
  margin-left: 30px;
  label {
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
    width: 50px;
    .stars {
      color: red;
    }
  }
}
</style>
<style lang="scss">
.myStatementApply {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/myStatementApply.vue